<template>
  <ResourceView :entityId="$route.params.modelId" entityClass="MachineModel">
  </ResourceView>
</template>


<script>
import ResourceView from "@/views/admin/machines/ResourceView.vue";

export default {
  name: "ViewMachineModelResources",
  components: {
    ResourceView,
  },

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style scoped></style>